import {Component, OnInit, HostListener, ViewChild} from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Subscription } from "rxjs/Subscription";
import {NgbDateStruct, NgbCalendar, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter} from '../../@theme/pipes/dateFormatPicker';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalDataSource } from 'ng2-smart-table';
import {AccionTablaArchivosEntidadComponent } from '../../custom_components/AccionTablaArchivosEntidad/AccionTablaArchivosEntidad.component'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AccionDescargarEntradaComponent } from '../../custom_components/AccionDescargarEntrada/AccionDescargarEntrada.component';

@Component({
  selector: 'ngx-perfil-usuario',
  templateUrl: './perfil-usuario.component.html',
  styleUrls: ['./perfil-usuario.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService,NgbModalConfig, NgbModal,{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}]
})
export class PerfilUsuarioComponent implements OnInit {
  myForm: FormGroup;
  misActividades:any;
  ArchivoSeleccionado:any = "";
  Usuario:any;
  ListadoBajas:any;
  TipoDocumentos:any;
  DomiciliosDelete: Array<any>;
  listB:any;
  baja:any;
  esEmpresa:boolean = false;
  activarGuardar:boolean = true;
  seletedAcceso: any = "0";
  TablaArchivosAjustes = {
		hideSubHeader: true,
		noDataMessage: 'No se han encontrado datos',
		rowClassFunction: function (row) {
			return 'text-center';
    },
    delete: {
      deleteButtonContent: '<i class="fas fa-trash"></i>',
      confirmDelete: true,
    },
		pager: {
			display: true,
			perPage: 10//2
		},
		columns: {
			archivoId: {
				title: 'ID',
				filter: false,
				sort: false,
				class: 'text-center'
			},
			nombreArchivo: {
				title: 'Nombre Archivo',
				filter: false,
				sort: false,
				class: 'text-center'
      },
			accion: {
				title: 'Otras acciones',
				type: 'custom',
				renderComponent: AccionTablaArchivosEntidadComponent,
				filter: false,
				sort: false,
				class: 'text-center'
			}
		},
		actions: {
      columnTitle: "Acciones",
			edit: false,
			add: false,
			delete: true
		}
  };
  
  TablaArchivosItems: LocalDataSource = new LocalDataSource();

  TablaHistoricoAjustes = {
		hideSubHeader: true,
		noDataMessage: 'No se han encontrado datos',
		rowClassFunction: function (row) {
			return 'text-center';
    },
		pager: {
			display: true,
			perPage: 10//2
		},
		columns: {
			HistoricoSocioId: {
				title: 'ID',
				filter: false,
				sort: false,
				class: 'text-center'
			},
			Estado: {
				title: 'Estado',
				filter: false,
				sort: false,
				class: 'text-center'
      },
			Inicio: {
				title: 'Inicio',
				filter: false,
				sort: false,
				class: 'text-center'
      },
			Fin: {
				title: 'Fin',
				filter: false,
				sort: false,
				class: 'text-center'
      }
		},
		actions: {
      columnTitle: "Acciones",
			edit: false,
			add: false,
			delete: false
		}
  };
  
  TablaHistoricoItems: LocalDataSource = new LocalDataSource();
  settingsMisActividades = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Descargar entrada",
      add: false,
      edit: false,
      delete:false,
      /*custom: [
        { name: 'edit', title: '<i class="fas fa-file-download"></i>' },
      ],*/
    },
    columns: {
      accion: {
				title: 'Descargar entrada',
				type: 'custom',
				renderComponent: AccionDescargarEntradaComponent,
				filter: false,
				sort: false,
				class: 'text-center',
			},
      Nombre: {
        title: 'Título',
        type: 'string',
        filter: false
      },
      Edicion: {
        title: 'Edición',
        type: 'string',
        filter: false
      },
      Tipo: {
        title: 'Tipo',
        type: 'string',
        filter: false
      },
      FechaInicio: {
        title: 'Inicio',
        type: 'string',
        filter: false,
        valuePrepareFunction: (date) => {
					if (date) {
						return this.datepip.transform(date, "dd-MM-yyyy");
					}
				}
      },
      FechaFin: {
        title: 'Fin',
        type: 'string',
        filter: false,
        valuePrepareFunction: (date) => {
					if (date) {
						return this.datepip.transform(date, "dd-MM-yyyy");
					}
				}
      },
    },
  };
  sourceMisActividades: LocalDataSource = new LocalDataSource();

  settingsMisActividadesEmpresa = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
      delete:false,
    },
    columns: {
      Nombre: {
        title: 'Título',
        type: 'string',
        filter: false
      },
      Empleado:{
        title: 'Usuario',
        type: 'string',
        filter: false
      },
      Edicion: {
        title: 'Edición',
        type: 'string',
        filter: false
      },
      Tipo: {
        title: 'Tipo',
        type: 'string',
        filter: false
      },
      FechaInicio: {
        title: 'Inicio',
        type: 'string',
        filter: false,
        valuePrepareFunction: (date) => {
					if (date) {
						return this.datepip.transform(date, "dd-MM-yyyy");
					}
				}
      },
      FechaFin: {
        title: 'Fin',
        type: 'string',
        filter: false,
        valuePrepareFunction: (date) => {
					if (date) {
						return this.datepip.transform(date, "dd-MM-yyyy");
					}
				}
      }
    },
  };
  sourceMisActividadesEmpresa: LocalDataSource = new LocalDataSource();
  Domicilios: Array<any>;
  RedesSociales: Array<any>;
  RedesSocialesDelete: Array<any>;
  SelectRedSocial: Number;
  OpenModal: any;
  DatosUsuario: any;
  ContenidoVisible: Boolean;
  FechaNacimiento: any;
  SolicitudAlta: Boolean = false;
  parametrosUrl: any;

  EsEmpresaInstitucion: Number = 0;
  EsSocio: Number = 0;

  ListadoActividadesProfesionales: any;
  ListadoEspecialidadesProfesionales: any;
  ListadoFormasPago: any;
  afuConfig: any;
  Token: any;

  ItemsTablaArchivos: Array<any> = [];
  ItemsTablaHistorico: Array<any> = [];
  ResultadoArchivos: any;

  fileData: File = null;
  ListadoCargosAsociacion: any;
  ultimoEstadoFecha: any;
  CargoEnDirectiva: String;

  FormaPagoVisible: Boolean = false;
  EspecialidadesVisible: Boolean = false;
  MotivoBaja: String = "";
  selectedNotificaciones:any = "0";
  notifiacionesUser:boolean;
  notificacionesMuros:boolean;
  notificacionesForos:boolean;
  notificacionesSeguimiento:boolean;
  TipoEmpresaInstitucion = [
    { value: '0', label: 'Es persona física', checked: true},
    { value: '1', label: 'Es empresa o institución', checked: false},
  ];


  TipoSocioNoSocio = [
    { value: '0', label: 'No socio', checked: true},
    { value: '1', label: 'Socio', checked: false },
  ];

  options = [
    { value: '0', label: 'No quiero recibir notificaciones en mi email', checked: true },
    { value: '1', label: 'Si, quiero recibir las notificaciones que indico', checked: false },
  ];

  constructor(private datepip: DatePipe,private _route: ActivatedRoute, private utilidades: UtilidadesService,config: NgbModalConfig, private modalService: NgbModal, private _http : PeticionesHttpBackEndService, private DatePipe: DatePipe,public fb: FormBuilder) { 
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    config.backdrop = 'static';
    config.keyboard = false;
    this.Domicilios = [];
    this.RedesSociales = [];
    this.DomiciliosDelete = [];
    this.RedesSocialesDelete = [];
    this.SelectRedSocial = 0;
    this.ContenidoVisible = false;
    this._route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
    });
  this.DatosUsuario = {Entidad:{},FormasPago:{}}
  this.ListadoActividadesProfesionales = {Actividades:[]};
  this.ListadoEspecialidadesProfesionales = {Especialidades:[]};
  this.ListadoBajas = {MotivoBaja:[]};
  this.ListadoFormasPago = {FormasPago:[]};
  this.ListadoCargosAsociacion = {CargosAsociacion:[]};
  /* Opcion primera select */
  this.ListadoCargosAsociacion.CargosAsociacion.push({_cargo_asociacion_id:0,_nombre:"Seleccione un cargo"});
  this.ListadoActividadesProfesionales.Actividades.push({_entidad_actividad_id:0,_nombre:"Seleccione actividad"});
  this.ListadoEspecialidadesProfesionales.Especialidades.push({_entidad_especialidad_id:0,_nombre:"Seleccione especialidad"});
  this.ListadoBajas.MotivoBaja.push({_motivo_baja_id:0,_descripcion:"Seleccione un motivo"});
  this.ListadoFormasPago.FormasPago.push({_forma_pago_id:0,_nombre:"Seleccione forma de pago"});
  /* --------------------- */
  this.myForm = this.fb.group({
    'emailPrincipal':['',[/*Validators.required*/,Validators.email]],
    'emailSecundario':['',[/*Validators.required*/,Validators.email]],
    'dniEmpresa':['',[/*Validators.required*/,Validators.pattern]],
    'dniFisica':['',[/*Validators.required*/,Validators.pattern]],
    'telefono':['',[/*Validators.required*/,Validators.pattern]],
  });
  //this.notifiacionesUser = false;
  //this.notificacionesMuros = false;
 // this.notificacionesForos = false;
  this.selectedNotificaciones = "0";
  }

fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
}

handleFileInput(event){
this.fileData = event.target.files[0];
}

onSubmit() {
  this._http.getUsuario().subscribe(
    result => {
      this.Usuario = result;
      let resultado;
      const formData = new FormData();
      formData.append('file', this.fileData);
      this._http.uploadFileId(formData,this.Usuario.Entidad._entidad_id)
        .subscribe(res => {
          resultado = res;
          if (resultado.Code == 200){
            this.ArchivoSeleccionado = "";
            this.listarArchivos();
            this.utilidades.notificationSuccess("Correcto","El archivo ha sido subido correctamente","top-left");
          }else{
            this.ArchivoSeleccionado = "";
            this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
          }
          
        })
    }
  );

}

listarArchivos(){
  this.ItemsTablaArchivos = [];
  this._http.getAllReg("v1/archivosEntidad/"+this.parametrosUrl["EntidadId"]+"").subscribe(
    result => {
      this.ResultadoArchivos = result;
      if (this.ResultadoArchivos.Code == 200 ){
        for (let Archivo of this.ResultadoArchivos.Archivos) { 
          this.ItemsTablaArchivos.push({archivoId:Archivo._archivo_entidad_id,nombreArchivo:Archivo._archivo_nombre_original});
        }
        this.TablaArchivosItems.load(this.ItemsTablaArchivos);
      }
    },
    error => {
      if (error.error.code == 401){
        /* Si hay un error 401 es que el token no es válido, por lo tanto, redirecciono a login */
        //this.router.navigate(['/auth/login']);
     }
    }
  );
}

  ngOnInit() {
    this._http.getAllReg("v1/EntidadesActividades").subscribe(
      result => {
        let resultadoActividades: any;
        resultadoActividades = result;
        for (let actividad of resultadoActividades.Actividades){
          this.ListadoActividadesProfesionales.Actividades.push({_entidad_actividad_id:actividad._entidad_actividad_id,_nombre:actividad._nombre});
        }
      },
      error => {

      }
    );

    this._http.getAllReg("v1/CargosAsociacion").subscribe(
      result => {
        let resultadoCargos: any = result;
        for (let cargosAsociacion of resultadoCargos.CargosAsociacion){
          this.ListadoCargosAsociacion.CargosAsociacion.push({_cargo_asociacion_id:cargosAsociacion._cargo_asociacion_id,_nombre:cargosAsociacion._nombre});
        }
      },
      error => {

      }
    );

    this._http.getAllReg("v1/EntidadesEspecialidades").subscribe(
      result => {

        let resultadoEspecialidades: any;
        resultadoEspecialidades = result;

        for (let especialidad of resultadoEspecialidades.Especialidades){
          this.ListadoEspecialidadesProfesionales.Especialidades.push({_entidad_especialidad_id:especialidad._entidad_especialidad_id,_nombre:especialidad._nombre});
        }

      },
      error => {

      }
    );

    this._http.getAllReg("v1/FormasPago").subscribe(
      result => {
        let resultadoFormasPago: any;
        resultadoFormasPago = result;
        for (let formaPago of resultadoFormasPago.FormasPago){
          this.ListadoFormasPago.FormasPago.push({_forma_pago_id:formaPago._forma_pago_id,_nombre:formaPago._nombre});
        }
      },
      error => {

      }
    );
    this._http.getOneReg("v1/admin/entidad",this.parametrosUrl["EntidadId"]).subscribe(
      result => {
        this.ItemsTablaHistorico = [];
        this.DatosUsuario = result;
        this.TipoDocumentos = this.DatosUsuario.TipoDocumentos;

        this.seletedAcceso = this.DatosUsuario.Entidad._autentificacion_dos_pasos ? "1" : "0";
       
        let FechaFin;
        this.ContenidoVisible = true;
        for (var i=0; i < this.DatosUsuario.Domicilios.length;i++){
          this.DatosUsuario.Domicilios[i].identificador = Math.floor((Math.random() * 1000000000000) + 1);
        }
        for (var i=0; i < this.DatosUsuario.RedesSociales.length;i++){
          this.DatosUsuario.RedesSociales[i].identificador = Math.floor((Math.random() * 1000000000000) + 1);
        }

        

        if (this.DatosUsuario.Historico.length > 0){
          this.ultimoEstadoFecha = this.DatosUsuario.Historico[0].Fecha;
          for (var i = 0; i < this.DatosUsuario.Historico.length; i++){
          
            var anterior = i - 1;
            if (i != 0){
              FechaFin = this.DatosUsuario.Historico[anterior].Fecha;
            }else{
              FechaFin = "-";
            }
  
            this.ItemsTablaHistorico.push({HistoricoSocioId:this.DatosUsuario.Historico[i].HistoricoSocioId,Estado:this.DatosUsuario.Historico[i].NombreEstado,Inicio:this.DatosUsuario.Historico[i].Fecha,Fin:FechaFin});
          }
          this.TablaHistoricoItems.load(this.ItemsTablaHistorico);
        }
        
        this.Domicilios = this.DatosUsuario.Domicilios;
        this.RedesSociales = this.DatosUsuario.RedesSociales;
        this.DatosUsuario.Entidad._fecha_nacimiento  = this.DatosUsuario.Entidad._fecha_nacimiento != null ?  this.datepip.transform(this.DatosUsuario.Entidad._fecha_nacimiento, "dd-MM-yyyy") : "";
        this.SolicitudAlta = this.DatosUsuario.SolicitudAltaSocio;
        this.DatosUsuario.CargoEnDirectiva ? this.CargoEnDirectiva = this.DatosUsuario.CargoEnDirectiva._nombre : '';
        this.DatosUsuario.Entidad.tipoSocioCambiado = false;
        if(this.DatosUsuario.Entidad._es_empresa_institucion){
          this.esEmpresa  =this.DatosUsuario.Entidad._es_empresa_institucion;
           this._http.getActividadesById("v1/misActividadesEmpresa",this.DatosUsuario.Entidad._entidad_id).subscribe(
                  result => {
                  this.misActividades = result;
                    this.sourceMisActividadesEmpresa.load(this.misActividades.MisActividades);
                  },
                  error => {

                  }
            );
        }else{
          this.esEmpresa  =this.DatosUsuario.Entidad._es_empresa_institucion;
         this._http.getActividadesById("v1/misActividades",this.parametrosUrl["EntidadId"]).subscribe(
            result => {
            this.misActividades = result;
              this.sourceMisActividades.load(this.misActividades.MisActividades);
            
            },
            error => {

            }
          );
         /*    this.misActividades = [];
            this.misActividades.push({Nombre:"Simofny 4",Edicion:1,Tipo:1,FechaInicio:new Date(),FechaFin:new Date(),ActividadId:1},{Nombre:"Simofny 4",Edicion:1,Tipo:1,FechaInicio:new Date(),FechaFin:new Date(),ActividadId:19});
            this.sourceMisActividades.load(this.misActividades);*/
        }
      }
      
    );

    this._http.getMotivosBajas("v1/motivoBaja").subscribe(
      result => {
      let resultadoMotivoPago: any;
        resultadoMotivoPago = result;
        for (let motivoBaja of resultadoMotivoPago.MotivoBaja){
          this.ListadoBajas.MotivoBaja.push({_motivo_baja_id:motivoBaja._motivo_baja_id,_descripcion:motivoBaja._descripcion});
        }
      },
      error => {

      }
    );

    this._http.getAllReg("v1/getNotificacionesSocial/"+this.parametrosUrl["EntidadId"]+"").subscribe(
      result => {
        let resultadosNotificaciones:any = result;
        if (resultadosNotificaciones.Code == 200 ){
          if(resultadosNotificaciones.NotificacionesSocial !== undefined){
            let not = resultadosNotificaciones.NotificacionesSocial;
            if(!not._post_usuarios &&  !not._post_muros && !not._post_publicaciones && !not._aviso_seguimiento){
              this.selectedNotificaciones = "0";
              this.notifiacionesUser = false;
              this.notificacionesMuros = false;
              this.notificacionesForos = false;
              this.notificacionesSeguimiento = false;
            }else{
              this.selectedNotificaciones = "1";
              this.notifiacionesUser = resultadosNotificaciones.NotificacionesSocial._post_usuarios;
              this.notificacionesMuros = resultadosNotificaciones.NotificacionesSocial._post_muros;
              this.notificacionesForos = resultadosNotificaciones.NotificacionesSocial._post_publicaciones;
              this.notificacionesSeguimiento = resultadosNotificaciones.NotificacionesSocial._aviso_seguimiento;
            }
            
          }else{
            this.selectedNotificaciones = "0";
          }
        }
      },
      error => {
      }
    );

    this.listarArchivos();


  }

  open(content) {
    this.OpenModal = this.modalService.open(content);
  }
  fechaChange(event){
    this.DatosUsuario.Entidad._fecha_nacimiento = this.datepip.transform(event, "dd-MM-yyyy");
  }

  cambiaFechaNacimiento(event){
    let dia = event.day;
    let mes = event.month;
    
    if (dia < 10){ dia = "0"+event.day;} 
    if (mes < 10){ mes = "0"+event.month;} 

    let fecha = event.year+"-"+mes+"-"+dia+"";
    this.FechaNacimiento = fecha;
  }

  LogoRed:any;
  selectRedSocial(event){
    this.LogoRed =  this.DatosUsuario.ListRedesSociales[event.target.value-1]._logo;
    this.SelectRedSocial = event.target.value;
  }



  submitAddDirecciones(){
    this.Domicilios.push({"identificador":Math.floor((Math.random() * 1000000000000) + 1),"_direccion":"","_codigo_postal":"","_localidad":"","_pais":"","_provincia":"","_es_alternativa":0,"_es_particular":1,"_es_profesional":0,"_domicilio_entidad_id":this.Domicilios[this.Domicilios.length-1] != null ? ((this.Domicilios[this.Domicilios.length-1]._domicilio_entidad_id)+1) : null});
  }

  public submitAddRedSocial(){
    if (this.SelectRedSocial == 0){
      this.utilidades.notificationWarning("Aviso","Tienes que seleccionar una red social para poder añadirla","top-left");
    }else{
      this.RedesSociales.push({"identificador":Math.floor((Math.random() * 1000000000000) + 1),"_comentario":"","_red_social_id":this.SelectRedSocial,"_red_social_entidad_id":"","_entidad_id":"","_url":"","_logo":this.LogoRed});
    }  
    this.SelectRedSocial = 0;
    this.OpenModal.close();
  }

  /*deleteDireccion(event){
    if (window.confirm('¿Seguro que quieres eliminar esta dirección?')) {
      for(var i=0;i<this.Domicilios.length;i++){
        if (this.Domicilios[i]._domicilio_entidad_id == event.id){
          this.Domicilios.splice(i, 1 );
        }
      }
    } else {
      event.confirm.reject();
    }
  }*/

  deleteDireccion(event){
    if (window.confirm('¿Seguro que quieres eliminar esta dirección?')) {
      for(var i=0;i<this.Domicilios.length;i++){
        if (this.Domicilios[i]._domicilio_entidad_id == event.id){
          this.DomiciliosDelete.push(this.Domicilios[i]);
          this.Domicilios.splice(i, 1 );
        }
      }
    } else {
      event.confirm.reject();
    }
  }

  public deleteRedSocialSocio(event){
    if (window.confirm('¿Seguro que quieres eliminar esta red social?')) {
      for(var i=0;i<this.RedesSociales.length;i++){
        if (this.RedesSociales[i].identificador == event.identificador){
          this.RedesSocialesDelete.push(this.RedesSociales[i]);
          this.RedesSociales.splice(i, 1 );
        }  
      } 
    }
  }

  public cambioValorArrayRedesSociales(event){
    for(var i=0;i<this.RedesSociales.length;i++){
      if (this.RedesSociales[i].identificador == event.identificador){
        if (event.inputType == "text"){
          switch(event.key){
            case "_url": this.RedesSociales[i]._url = event.value;break;
            case "_comentario": this.RedesSociales[i]._comentario = event.value;break;
          }
        }
      }
    } 
  }

  setDatoObjetoEntidad(event){
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if (elemento == "INPUT" && tipo == "text"){
      switch(event.target.name){
        
        case "_nombre": this.DatosUsuario.Entidad._nombre = event.target.value; break;
        case "_apellidos": this.DatosUsuario.Entidad._apellidos = event.target.value; break;
        case "_email_secundario": this.DatosUsuario.Entidad._email_secundario = event.target.value; break;
        case "_fecha_nacimiento": this.DatosUsuario.Entidad._fecha_nacimiento = event.target.value; break;
        case "_d_n_i_c_i_f": this.DatosUsuario.Entidad._d_n_i_c_i_f = event.target.value; break;
        case "_cargo": this.DatosUsuario.Entidad._cargo = event.target.value; break;
        case "_empresa_institucion": this.DatosUsuario.Entidad._empresa_institucion = event.target.value; break;
        case "_telefono": this.DatosUsuario.Entidad._telefono = event.target.value; break;
        case "_email": this.DatosUsuario.Entidad._email = event.target.value; break;
       
        /* Datos profesionales */
        case "Cargo": this.DatosUsuario.Entidad._cargo_empresa_institucion = event.target.value; break;
        case "EmpresaInstitucion": this.DatosUsuario.Entidad._nombre_empresa_institucion = event.target.value; break;

        /* Datos de cobro */
        case "EntidadBancaria": this.DatosUsuario.FormasPago._entidad_bancaria = event.target.value; break;
        case "IBAN": this.DatosUsuario.FormasPago._i_b_a_n = event.target.value; break;
      }
      }
      
      /* if (elemento == "textarea"){
        switch(event.target.name){
          case "_motivo": this.MotivoBaja = event.target.value; break;
        }
      }
      */
  
    if (elemento == "INPUT" && tipo == "checkbox"){
      switch(event.target.name){
        case "RecibirOfertasEmpleo": 
        if (event.target.checked == true){
          this.DatosUsuario.Entidad._recibir_ofertas_empleo = 1
        }else{
          this.DatosUsuario.Entidad._recibir_ofertas_empleo = 0;
        }
        break;
        case "IncluirDirectorio": 
        if (event.target.checked == true){
          this.DatosUsuario.Entidad._incluir_directorio = 1
        }else{
          this.DatosUsuario.Entidad._incluir_directorio = 0;
        }
        break;
      }
    }

    if (elemento == "SELECT" && tipo == "select-one"){
      switch(event.target.name){
        case "Especialidad": this.DatosUsuario.Entidad._entidad_especialidad_id = event.target.value; break;
        case "Actividad": this.DatosUsuario.Entidad._entidad_actividad_id = event.target.value; break;
        case "FormaPagoId": this.DatosUsuario.FormasPago._forma_pago_id = event.target.value; break;
        case "EsSocio": this.DatosUsuario.Entidad._es_socio = event.target.value; break;
        case "CargoEnDirectiva": this.DatosUsuario.Entidad._cargo_asociacion_id = event.target.value; break;
        case "selectBaja": this.baja = event.target.value; break;
        case "TipoDocumento":  this.DatosUsuario.Entidad._tipos_doc_identidades_id = event.target.value;break;
        //case "_estado_socio": this.EstadoSocio = event.target.value; break;
      }
    }
  }

  public cambioValorArrayDirecciones(event){
    for(var i=0;i<this.Domicilios.length;i++){
      if (this.Domicilios[i].identificador == event.identificador){
        if (event.inputType == "text"){
          switch(event.key){
            case "_direccion": this.Domicilios[i]._direccion = event.value;break;
            case "_codigo_postal": this.Domicilios[i]._codigo_postal = event.value;break;
            case "_pais": this.Domicilios[i]._pais = event.value;break;
            case "_localidad": this.Domicilios[i]._localidad = event.value;break;
            case "_provincia": this.Domicilios[i]._provincia = event.value;break;
          }
        }else if(event.inputType == "radio"){
          this.Domicilios[i]._es_particular = event._es_particular;
          this.Domicilios[i]._es_profesional = event._es_profesional;
          this.Domicilios[i]._es_alternativa = event._es_alternativa;
        }
      }
    } 
  }

  SolititaBajaSocio(){
    let resultado: any;
    if(this.baja == undefined){
      this.utilidades.notificationWarning("Aviso","Debe seleccionar un motivo","top-left");
    }else{
        this._http.postRequest("v1/bajaSocio/"+this.DatosUsuario.Entidad._entidad_id+"",{Motivo:this.baja}).subscribe(
          result => {
            resultado = result;
            if (resultado.Code == 200){
              this.utilidades.notificationSuccess("Aviso","Tu solicitud de baja ha sido enviada, la resolveremos lo antes posible.","top-left");
              this.MotivoBaja = "";
            }
          },
          error => {

          }
        )
    }
  }

  guardaObjeto(){
    if((this.DatosUsuario.Entidad._tipos_doc_identidades_id == 1 && this.myForm.get('dniFisica').hasError('pattern')) || 
    this.myForm.get('emailPrincipal').hasError('email') || this.myForm.get('emailSecundario').hasError('email') || this.myForm.get('telefono').hasError('pattern')
    || this.myForm.get('dniEmpresa').hasError('pattern')){
      this.utilidades.notificationWarning("Aviso","Los campos son invalidos","top-left");
    }else{
        let resultado: any;
        this.DatosUsuario.RedesSociales = this.RedesSociales;
        this.DatosUsuario.RedesSocialesDelete = this.RedesSocialesDelete;
        this.DatosUsuario.Domicilios = this.Domicilios;
        this.DatosUsuario.DomiciliosDelete = this.DomiciliosDelete;
        this.DatosUsuario.Entidad.tipoSocioCambiado = false;
        this.DatosUsuario.Entidad._autentificacion_dos_pasos = this.seletedAcceso == "0" ? false : true;
        if(this.selectedNotificaciones == "0"){
          this.notificacionesMuros = false;
          this.notificacionesForos = false;
          this.notifiacionesUser = false;
          this.notificacionesSeguimiento = false;
        }
        this.DatosUsuario.NotificacionesSocial = {
          "postMuros":this.notificacionesMuros == undefined ? false : this.notificacionesMuros,
          "postPublicaciones":this.notificacionesForos == undefined ? false : this.notificacionesForos,
          "postUsuarios":this.notifiacionesUser == undefined ? false : this.notifiacionesUser,
          "avisoSeguimiento":this.notificacionesSeguimiento == undefined ? false : this.notificacionesSeguimiento,
          "recibirNotificaciones":this.selectedNotificaciones == "1" ? true : false
        };
        this._http.updateOneReg("v1/actualizaEntidad",this.DatosUsuario.Entidad._entidad_id,{Data:this.DatosUsuario}).subscribe(
          result => {
            resultado = result;
            if (resultado.Code == 200){
              this.utilidades.notificationSuccess("Aviso","El perfil ha sido actualizado correctamente","top-left");
            }
          }
        )
    }
  }

  onDeleteConfirm(event): void {
    if (window.confirm('¿Seguro que quieres eliminar este archivo?')) {
      let resultado;
      this._http.deleteOneReg("v1/deleteFile",event.data.archivoId).subscribe(
        result => {
          resultado = result;
          if (resultado.Code == 200){
       
          }
        }
      );
      event.confirm.resolve();
    } else {
      event.confirm.reject();
    }
    
  }
  resultadoRequest:any;
  tipo:any;
  onCustomAction(event) {
    this._http.postGeneralConParametro("v1/generarEntrada",{Data:event.data}).subscribe( 
      result => {
        this.resultadoRequest = result;
       const win = window.open("","_blank");
        let html = '';
        let cadena = "";
            this.tipo = "application/pdf";
          cadena =  this.tipo;
        const linkSource = 'data:'+cadena+';base64,' + this.resultadoRequest.Archivo;
        const downloadLink = document.createElement("a");
        const fileName = "Entrada - "+event.data.Nombre;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click(); 
        /*  tamaño = "width=100% height=100%";
        html += '<html>';
        html += '<body style="margin:0!important">';
          html += '<a href="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'" type="'+cadena+'" >Descargar</a>.</p>';
          html += '<iframe '+tamaño+' src="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'" type="'+cadena+'" frameborder="0" allowfullscreen><iframe/>';
        //html += '<img src="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'" type="'+cadena+'" >'
        //html += '<iframe style="border: none" '+tamaño+' src="https://view.officeapps.live.com/op/embed.aspx?src="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'&embedded=true" type="'+cadena+'"></iframe>';
      
        html += '</body>';
        html += '</html>';*/

        setTimeout(() => {
          win.document.write(html);
        }, 0);
      },
      error => {
        this.utilidades.notificationWarning("Error",""+"Ocurrio un problema en el servidor"+"","top-left");
      }
    );
  }

  changeCheckUser(evento){
    this.notifiacionesUser = evento.target.checked
  }
  changeCheckMuros(evento){
    this.notificacionesMuros = evento.target.checked
  }
  changeCheckForos(evento){
    this.notificacionesForos = evento.target.checked
  }
  changeCheckSeguimiento(evento){
    this.notificacionesSeguimiento = evento.target.checked
  }

  onChangeTab(evento){
    if(evento.tabTitle == "Pestaña social"){
      this.activarGuardar = false;
    }else{
      this.activarGuardar = true;
    }
  }

}
